<template>
   <div class="full-page opendoor">
    <van-empty image="error" description="无法使用小程序，请更新微信" />
  </div>
</template>
<script>
import { Empty } from "vant";
export default {
  components: {
    [Empty.name]: Empty,
  },
};
</script>
<style lang="less" scoped>
.opendoor{
  background-color:white;
}
</style>